import {call, ForkEffect, put, takeLatest, takeEvery} from 'redux-saga/effects';
import {
    updateAnalyticsDataAction,
    updateQuestionAnswersCountAction,
    updateQuestionReportAction,
    updateSlidesAnalyticsAction,
} from '../actions/analytics.actions';
import {
    createSlidesAnalyticsService,
    fetchQuestionAnswersCount,
    fetchQuestionReport,
    fetchSlidesAnalytics,
    postForAnalyticsData,
} from '../../service/analytics.service';
import {
    CREATE_SLIDES_ANALYTICS,
    FETCH_ANALYTICS_DATA,
    FETCH_QUESTION_ANSWERS_COUNT,
    FETCH_QUESTION_REPORT,
    FETCH_SLIDES_ANALYTICS,
    ICreateSlidesAnalyticsActionType,
    IFetchAnalyticsDataActionType,
    IFetchQuestionAnswersCountActionType,
    IFetchQuestionReportActionType,
    IFetchSlidesAnalyticsActionType,
} from '../actions/types/analytics.actions.types';

function* createSlidesAnalyticsSaga(action: ICreateSlidesAnalyticsActionType): Generator<void> | void {
    const slidesAnalytics = yield call(createSlidesAnalyticsService, action.payload.runFileId, action.payload.presentationId);
    if (slidesAnalytics) {
        yield put(updateSlidesAnalyticsAction(slidesAnalytics));
    }
}

function* fetchAnalyticsSaga(action: IFetchAnalyticsDataActionType): Generator<void> | void {
    const analyticsData = yield call(postForAnalyticsData, action.searchForm);
    yield put(updateAnalyticsDataAction(analyticsData));
}

function* fetchQuestionReportSaga(action: IFetchQuestionReportActionType): Generator<void> | void {
    const questionReport = yield call(fetchQuestionReport, action.elementId, action.roomRunfileId);
    if (questionReport) {
        yield put(updateQuestionReportAction(questionReport));
    }
}

function* fetchQuestionAnswersCountSaga(action: IFetchQuestionAnswersCountActionType): Generator<void> | void {
    const questionAnswersCount = yield call(fetchQuestionAnswersCount, action.elementId, action.roomId, action.roomRunFileId);
    if (questionAnswersCount) {
        yield put(updateQuestionAnswersCountAction(questionAnswersCount));
    }
}

function* fetchSlidesAnalyticsSaga(action: IFetchSlidesAnalyticsActionType): Generator<void> | void {
    const slidesAnalytics = yield call(fetchSlidesAnalytics, action.runfileId);
    if (slidesAnalytics) {
        yield put(updateSlidesAnalyticsAction(slidesAnalytics));
    }
}

export function* watchAnalyticsSaga(): Generator<ForkEffect<never>, void> {
    yield takeLatest(FETCH_ANALYTICS_DATA, fetchAnalyticsSaga);
    yield takeEvery(FETCH_QUESTION_REPORT, fetchQuestionReportSaga);
    yield takeLatest(FETCH_SLIDES_ANALYTICS, fetchSlidesAnalyticsSaga);
    yield takeLatest(CREATE_SLIDES_ANALYTICS, createSlidesAnalyticsSaga);
    yield takeEvery(FETCH_QUESTION_ANSWERS_COUNT, fetchQuestionAnswersCountSaga);
}
